import type { MouseEvent } from "react";
import { scrollToSection } from "@/pages/home/utils/scrollTo";

const footerLinks = [
  { id: "addresses", label: "最新可用地址" },
  { id: "steps", label: "访问步骤" },
  { id: "guide", label: "防走失指南" },
  { id: "troubleshoot", label: "打不开排查" },
  { id: "devices", label: "多设备访问" },
  { id: "safety", label: "安全提示" },
  { id: "faq", label: "常见问题" },
];

export default function SiteFooter() {
  const go = (e: MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    scrollToSection(id);
  };

  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-lg">
                91
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-heading font-bold text-lg text-foreground-950">91免费</span>
                <span className="text-xs text-foreground-700">地址发布 · 防走失导航</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed max-w-md">
              当官网地址变动时，打开本页即可获取最新可用入口。建议将本页加入书签，并在桌面与手机各保存一个入口，避免地址失效后无处可寻。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 text-xs text-foreground-700">
              <i className="ri-refresh-line" />
              页面最近同步：2026-10-10 09:30
            </p>
          </div>

          <div className="md:col-span-4">
            <h2 className="font-heading font-bold text-base text-foreground-950">页面导航</h2>
            <ul className="mt-4 grid grid-cols-2 gap-y-2 gap-x-4">
              {footerLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    onClick={(e) => go(e, link.id)}
                    className="text-sm text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h2 className="font-heading font-bold text-base text-foreground-950">使用提醒</h2>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-700 leading-relaxed">
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-accent-600 mt-0.5 shrink-0" />
                优先使用「主线路」入口
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-accent-600 mt-0.5 shrink-0" />
                打不开时依次切换备用线路
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-checkbox-circle-line text-accent-600 mt-0.5 shrink-0" />
                页面不会索取任何账号信息
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-foreground-700">
            © 2026 91免费 地址发布页 · 仅供地址导航使用，不提供注册与内容服务。
          </p>
          <p className="text-xs text-foreground-700">
            请通过本页获取入口，勿轻信来路不明的第三方链接。
          </p>
        </div>
      </div>
    </footer>
  );
}